module.exports = __webpack_public_path__ + "static/media/unlock_128x128.0e0c72db.ico";